// extracted by mini-css-extract-plugin
module.exports = {"facilityCategory":"facility_category_facilityCategory__3-bau","facilityCategoryTitle":"facility_category_facilityCategoryTitle__3Qr32"};